module.exports = __webpack_public_path__ + "static/media/scg-icon.9832b304.svg";